module.exports = __webpack_public_path__ + "assets/img/text1.3a631381.png";